import { Stack } from '@mui/material';
import type { Element } from '../../format/form-definition';
import { DrawerSection } from '../drawer/DrawerSection';
import { KindContent } from './KindContent';

export const GeneralSection = ({ element }: { element: Element }) => {
  return (
    <DrawerSection
      sections={[
        {
          id: 'general',
          title: 'General',
          content: (
            <Stack useFlexGap>
              <KindContent element={element} />
            </Stack>
          ),
        },
      ]}
    />
  );
};
